import { slugify } from "@certn/utils";

export function convertActionBarTextToTestIDFormat(
  primaryText: string,
  secondaryText: string | undefined,
  backText: string | undefined
): {
  convertedPrimaryText: string | undefined;
  convertedSecondaryText: string | undefined;
  convertedBackText: string | undefined;
} {
  const convertedPrimaryText = slugify(primaryText);
  const convertedSecondaryText = slugify(secondaryText);
  const convertedBackText = slugify(backText);
  return {
    convertedPrimaryText,
    convertedSecondaryText,
    convertedBackText,
  };
}
